export const USER_STATUSES = ['Active', 'Invited', 'Suspended'] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

/** A person at a client organization. */
export interface TenantUser {
  /** Cognito `sub`. */
  id: string;
  tenantId: string;
  /** Lowercase. Identity key within a tenant. */
  email: string;
  name: string;
  status: UserStatus;
  /** Exactly one user per tenant holds this. Changed only through a confirmed handoff. */
  isSuperadmin: boolean;
  /** Human-readable last activity, or invitation state. */
  last: string;
  groupIds: string[];
  createdAt: string;
}

export const STAFF_ROLES = ['superadmin', 'staff'] as const;
export type StaffRole = (typeof STAFF_ROLES)[number];

export const STAFF_ROLE_LABELS: Record<StaffRole, string> = {
  superadmin: 'Platform Owner',
  staff: 'DinoCloud staff',
};

export const STAFF_DOMAIN = 'dinocloud.com';

/** A DinoCloud employee's grant to enter the hub. Sign-in without one is rejected. */
export interface StaffAccess {
  /** Lowercase, always `@dinocloud.com`. */
  email: string;
  name: string;
  role: StaffRole;
  status: 'Active' | 'Revoked';
  grantedBy: string;
  grantedAt: string;
  last?: string;
}
